// extracted by mini-css-extract-plugin
module.exports = {"outer":"_9iYUe","text-one":"i94Wh"};